<template>
  <template v-if="moduleIndex !== undefined">
    <template v-if="model?.modules?.length !== 1">
      <WrapperCheckbox
        :modelValue="model?.modules?.[moduleIndex]?.estTraite"
        @update:model-value="(value) => updateModule('estTraite', moduleIndex!, value)"
        :alert-label="meta.modules?.at(moduleIndex)?.estTraite?.$messageErreurDirty"
        :disabled="meta.modules?.at(moduleIndex)?.estTraite?.$status === PropertyStatus.NotPresent"
        label="Demander un remboursement pour ce module"
        class="col-36"
        :readonly
      />
      <basic-alert v-if="koModule" :alert-label="koModule" />
      <basic-alert v-else :alert-label="okModule" :alert-type="'info'" />
    </template>
    <InformationSection
      :moduleIndex
      :key="moduleIndex"
    />
    <StagiaireSection
      :moduleIndex
      :key="moduleIndex"
    />
  </template>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue'
  import InformationSection from './sections/InformationSection.vue'
  import StagiaireSection from './sections/StagiaireSection.vue'
  import { DEMANDE_STORE } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/DR'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_DR')
  const { model, meta, readonly } = storeToRefs(store)

  const updateModule = store.setupArrayUpdaterWithKey<ModuleDTO>('modules')

  const contentStore = inject(DEMANDE_STORE)!
  const currentStep = contentStore.currentStep

  const moduleIndex = computed(() => {
    if (currentStep.value?.startsWith('Module')) {
      return Number(currentStep.value.split(' ')?.at(1)) - 1
    }
    return undefined
  })

  const koModule = computed(() => meta.value?.modules?.at(moduleIndex.value!)?.$messageErreur)
  const okModule = computed(() => {
    const count = model.value?.modules?.filter(m => m.estTraite)?.length ?? 0
    return `La demande de prise en charge porte sur ${ count } module${ count > 1 ? 's' : '' }`
  })
</script>

